<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="720">
    <v-card>
        <v-toolbar dense>
            SAFEKEEP ITEMS :  {{keep.trade_name}}
            <v-spacer/>
             <v-icon @click="emitToParent('close')">mdi-close</v-icon>
        </v-toolbar>
        <div class="pa-2">
            <v-data-table
                class="va-table mt-2"
                dense
                hide-default-footer=""
                disable-sort
                :headers="[
                 {text:'KEEP DATE'},
                  {text:'CODE'},
                  {text:'QTY', align:'right'},
                  {text:'REDEEMED', align:'right'},
                  {text:'INVOICE'},
                  {text:'STATUS', align:'right'}
                ]"
                :items="INKEEPS"
                >
                <template v-slot:body="{ items }">
                    <tbody>
                    <tr v-for="(item,index) in items" :key="index + 'k'">
                      <td>{{item.created | moment('MMM-DD-YYYY')}}</td>
                        <td>{{item.product}}</td>
                        <td class="text-right">{{item.redeemed}}/{{item.quantity}}</td>
                        <td class="text-right">
                          <template v-if="item.status=='available' && method !='manage'">
                             <input 
                             class="va-input pa-1"
                              type="number"
                               v-model="item.available"
                              />
                              <v-icon title="Redeem" color="secondary" @click="redeemedItem(item)">mdi-plus-box</v-icon>
                          </template>
                          <template v-else>
                            {{item.redeemed}}
                          </template>
                      </td>
                        <td>{{item.invoice}}</td>
                        <td class="text-right" :class="item.status=='redeemed'?'text-warning':'text-success'">{{item.status}}</td>
                    </tr>
                    <tr style="background: #efefef;"  v-if="method =='manage'">
                        <th></th>
                        <th>TOTAL</th>
                        <th class="text-right">{{keep.quantity}}</th>
                        <th class="text-right">{{keep.redeemed}}</th>
                        <th class="text-right"></th>
                          <th class="text-right"></th>
                    </tr>
                    </tbody>
                </template>
            </v-data-table>
             <v-card class="pa-2 mt-2" v-if="method =='manage'">
                <v-form
                ref="form"
                class="mt-3"
                v-model="valid"
                lazy-validation
              >
                  <v-row no-gutters dense color="secondary">
                      <v-col>
                        <v-autocomplete
                          :items="PRODUCTS"
                          v-model="newkeep.product"
                          dense
                          filled
                          item-text="code"
                          item-value="code"
                          outlined
                          hide-details
                          label="Product Code"
                          :rules="textRules"
                          required
                        />
                      </v-col>
                      <v-col>
                        <v-text-field
                        class="ml-1"
                        type="number"
                          dense
                          filled
                          outlined
                          hide-details
                           v-model="newkeep.quantity"
                          label="Qty"
                          :rules="textRules"
                          required
                        />
                        </v-col>
                        <span style="width: 30px;" >
                            <v-icon large @click="validate()" color="secondary">mdi-plus-box</v-icon>
                        </span>
                  </v-row>
                </v-form>
             </v-card>
        </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
    data: () => ({
        valid: true,
        newkeep:{},
        safe_keep_products:[],
         textRules: [
        v => !!v || 'Field is required'
      ],
    }),
  props: {
    show: {
        type: Boolean,
        default: false
    },
    method:{
        type: String,
        default: "manage"
    },
    keep: {
        type: Object,
        default: ()=>{}
    }
  },
  watch:{
      show(v) {
        if(v) {
          this.newkeep ={}
          this.getKeepItems()
        }
      }
  },
  computed:{
    PRODUCTS() {
      var empties = this.$store.state.products.reduce((o,i)=>{
        if(i.type=="empties") {
          o.push(i)
        }
        return o
      },[])
      return empties
    },
    INKEEPS(){
      var arr = this.safe_keep_products.reduce((o,i)=>{
        i.available = this.$IsNum(i.quantity) - this.$IsNum(i.redeemed)
        o.push(i)
        return o
      },[])
      return arr
    },
    UNIT_PRICE(){
        var price = this.PRODUCTS.reduce((res,item)=>{
            if(item.code == this.newkeep.product){
              res = item.price_per_unit
            }
              return res
        },'')
         console.log(price)
        return price
    }
  },
  methods: {
     validate () {
        if (this.$refs.form.validate()) {
           this.AddItem()
        }
    },
    emitToParent (data) {
      this.$emit('DialogEvent', data)
    },
    redeemedItem(item) {
       this.$emit('DialogEvent', item)
    },
    getKeepItems() {
          this.$http.post("keep/view_items", {customer:this.keep.customer}).then(response => {
              response.data.items !=null?this.safe_keep_products = response.data.items : this.safe_keep_products=[]
              }).catch(e => {
              console.log(e.data)
          })
    },
    AddItem(){
      this.newkeep.customer = this.$IsNum(this.keep.customer)
      this.newkeep.quantity = this.$IsNum(this.newkeep.quantity)
      this.newkeep.unit_price = this.UNIT_PRICE
      console.log(this.newkeep)
      this.$http.post("keep/add", this.newkeep).then(response => {
          this.GET_RESPONSE(response)
          this.keep.products.push(this.newkeep)
          this.newkeep ={}
          }).catch(e => {
          console.log(e.data)
      })
    }
  }
}
</script>
